import { Injectable } from '@angular/core';


import { OpcoesAssinatura } from './opcoes-assinatura.model';
import { UtilService } from '../providers/util-service';
import { UsuarioService } from '../providers/usuario-service';
import { Observable, of } from 'rxjs';


declare var setCampoAssinaturaTO: any;
declare var assinar: any;
declare var BryApiModule: any;
declare var inicializaModal: any;

@Injectable()
export class AssinaturaService {

  constructor(private utilService: UtilService, private usuarioService: UsuarioService) {
  }

  iniciarAssinatura(opcoes: OpcoesAssinatura) {
  
    const assinaturaTo = this.getAssinaturaTO();
  
    assinaturaTo.caminhoArquivos = opcoes.arquivos;

    setCampoAssinaturaTO(
      assinaturaTo,
      `${this.utilService.urlBase}assinatura/`,
      opcoes.dadosBackEndCallBack,
      opcoes.cpfUsuarioLogado,
      `${this.utilService.urlBase}assinatura/call-back`,
      this.usuarioService.usuarioAtual.token,
      opcoes.idPca,
      opcoes.tipoArquivo
      );
  
    }
  assinar() {
    assinar();
  }

  assinarPromise(): Promise<any> {
    return assinar();
  }

  getAssinaturaTO(): any {
  
  const dto = {
    tipoAssinatura: 'Attached',
    modoOperacao: 'ASSINATURA',
    algoritmoHash: 'SHA256',
    politicaAssinatura: 'ADRT',
    padrao: '8',
    certificado: '',
    dadosCadeiaCarimbo:	'basica',
    inicializado: '',
    cifrado: '',
    chaveException: '',
    detalheException: '',
    arquivo: '',
    caminhoArquivos: [],
    nomeSistema: 'AGORA',
    nomeAssinador: '',
    cpf: ''
  };
  
  return dto;
  }
  
  iniciarCertificados() {
    const certificates = BryApiModule.certificates;
    // BryApiModule.fillCertificateSelect(certificates);
    BryApiModule.iniciarCertificados(certificates);
  }

  isExtensaoInstalada() {
    //return BryApiModule.isExtensionInstalled();
    return true;
  }

  instalarExtensao() {
    inicializaModal('extensaoModal');
  }
}



// WEBPACK FOOTER //
// ./src/assinatura/assinatura-service.ts